const localstorageKeys = {
  AUTH_TOKEN: "AUTH_TOKEN",
  USER_PROFILE: "USER_PROFILE",
};

export default localstorageKeys;
